export const common = {
  nav: {
    home: 'Home',
    technologies: 'Technologies',
    finishing: 'Finishing',
    portfolio: 'Portfolio',
    preparation: 'File setup',
    faq: 'FAQ',
    contact: 'Contact',
  },

  hero: {
    badge: 'Self-adhesive labels',
    established: 'Since 1991',
    title1: 'Promedia',
    title2: 'Print',
    description:
      'Printing that turns ideas into recognizable products',
    primaryCta: 'View technologies',
    secondaryCta: 'File preparation',
  },

  technologies: {
    title: 'Printing',
    titleBold: 'technologies',
    intro:
      'Depending on the quantity, material and label application, we suggest digital or flexographic printing.',
    digital: {
      title: 'Digital printing',
      description:
        'Suitable for small and medium runs, multiple design versions and projects that require flexibility.',
    },
    flexo: {
      title: 'Flexographic printing',
      description:
        'A practical solution for larger runs and stable roll-label production.',
    },
    consulting: {
      title: 'Prepress consulting',
      description:
        'We can help with choosing the technology, material and finishing option based on the label use.',
      extraDescription:
        'This makes it easier to align the visual result, functionality and technical requirements before production starts.',
    },
  },

  finishing: {
    badge: 'Finishing',
    title: 'Details that shape the look of a label',
    description:
      'Finishing options are chosen based on the design, material and the effect the label should achieve.',
    items: {
      foil: {
        title: 'Foil stamping',
        description:
          'Foil can be used to highlight the logo, product name or decorative details.',
      },
      raised: {
        title: 'Raised varnish',
        description:
          'Raised varnish emphasizes selected elements and adds a tactile effect to the label.',
      },
      screen: {
        title: 'Screen printing',
        description:
          'Screen printing allows stronger ink deposits and specific visual effects.',
      },
      effects: {
        title: 'Combined effects',
        description:
          'Different finishing options can be combined when the material, design and technology allow it.',
      },
    },
  },

  portfolio: {
    title: 'Portfolio',
    titleBold: '',

    items: {
      wine: 'Textured materials',
      foil: 'Foil details',
      matte: 'Matte finish',
      glossy: 'Glossy finish',
      shape: 'Custom shapes',
      emboss: 'Raised details',
    },

    details: {
      wine:
        'Textured materials are often used for products with a more natural or refined visual style.',
      foil:
        'Foil highlights selected details and can make the label more visually distinctive.',
      matte:
        'A matte finish gives a calmer look and reduces reflection.',
      glossy:
        'A glossy finish emphasizes colors and creates a stronger visual effect.',
      shape:
        'Die-cutting allows labels to be produced in different shapes.',
      emboss:
        'Raised details are used to emphasize logos, symbols or decorative elements.',
    },
  },

  preparation: {
    badge: 'File preparation',
    title: 'Download file preparation guidelines',
    description:
      'The PDF document contains basic guidelines for preparing self-adhesive label files for print.',
    points: {
      format: 'Recommended file formats',
      colors: 'Color setup for print',
      bleed: 'Bleed, cutting line and safe area',
      resolution: 'Image resolution and basic technical requirements',
    },
    download: 'Download PDF',
    cardTitle: 'Preparation guide',
    cardText:
      'The document helps clients send files correctly and can make the prepress check faster.',
  },

  faq: {
    title: 'Frequently asked questions',
    description:
      'Answers to common questions before starting label production.',
    items: {
      digitalFlexo: {
        question: 'What is the difference between digital and flexographic printing?',
        answer:
          'Digital printing is suitable for small and medium runs, frequent changes and multiple design versions. Flexographic printing is more often used for larger runs and stable roll-label production.',
      },
      smallRuns: {
        question: 'Do you produce smaller quantities?',
        answer:
          'Yes, depending on the label type and requirements, smaller quantities are usually produced using digital printing.',
      },
      filePreparation: {
        question: 'Can you help with file preparation?',
        answer:
          'We can review the file and point out basic technical elements that should be corrected before printing.',
      },
      finishing: {
        question: 'Which finishing options can be combined?',
        answer:
          'Different finishing options such as foil, varnish and screen printing can be combined, depending on the material, design and production technology.',
      },
      price: {
        question: 'How is the label price calculated?',
        answer:
          'The price depends on size, quantity, material, printing technology, finishing options and file preparation complexity.',
      },
    },
  },

  contact: {
    title: 'Contact',
    titleBold: 'information',
    description:
      'For inquiries related to label production, you can contact us by email or phone.',
    email: {
      title: 'Email',
      description: 'Send us the basic information about your label.',
      address: 'promedia@orion.rs',
    },
    location: {
      mapEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11322.584368680678!2d20.4922909!3d44.80840069999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x475a658bddcf2c37%3A0xbcbf4ba404fff117!2sPROMEDIA%20d.o.o.!5e0!3m2!1sen!2srs!4v1765663832235!5m2!1sen!2srs',
    },
    phone: {
      title: 'Phone',
      description: 'You can call us for additional information.',
      number: '+381 11 3321919',
    },
  },

  footer: {
    tagline: 'Self-adhesive labels in digital and flexographic printing.',
  },
};